import { USER_ACTIONS } from '../../constants.js';

export function change_language(c_language) {
  return {
    type: USER_ACTIONS.CHANGE_LANGUAGE,
    c_language: c_language
  };
}

export function loginAction(wLogged, ccsLogged) {
  return {
    type: USER_ACTIONS.LOGIN,
    webLogged: wLogged,
    ccserverLogged: ccsLogged
  };
}

export function logout() {
  return {
    type: USER_ACTIONS.LOGOUT,
  };
}

export function userNoAction() {
  return {
    type: USER_ACTIONS.NONE,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_user_actions.js